import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { Url } from '@wix/da-url';
import { cleanLinkSrc } from '../../../components/utils/browser';
export const Viewer = ({ node, children })=>{
    var _node_attrs_datahashtag;
    let hashtag = (_node_attrs_datahashtag = node.attrs['data-hashtag']) !== null && _node_attrs_datahashtag !== void 0 ? _node_attrs_datahashtag : '';
    if (typeof hashtag !== 'string') {
        if (hashtag['data-hashtag'] && typeof hashtag['data-hashtag'] === 'string') {
            hashtag = hashtag['data-hashtag'];
        } else {
            return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
    }
    const href = cleanLinkSrc(Url.tagsPageLink(hashtag));
    return /*#__PURE__*/ React.createElement("a", _object_spread({
        href: href,
        target: "_blank",
        rel: "noreferrer noopener"
    }, node.attrs), "#", hashtag);
};
export default Viewer;

//# sourceMappingURL=Viewer.js.map